var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_3813)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_3813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H9.25V20H0.5V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 0H28V20H19.25V0Z",
    fill: "#F93939"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 0.625,
    width: 26.25,
    height: 18.75,
    stroke: "#C3645E",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_3813"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_3813"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.a70ba5d7c22e4f2a105230e2a37816c7.svg";
export { ForwardRef as ReactComponent };